import React from 'react';
import { DetailItem } from '@/components/dataItem/data-view-item';
import { ISetting } from '@/interfaces/setting';
import { formatNumber } from '@/utils/dataUtils';

interface IProps {
  setting?: ISetting;
}

const CompanyMaintainView = ({ setting }: IProps) => {
  return (
    <div className="grid grid-cols-1 w-full gap-3 mt-3">
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ชื่อบริษัท"
        detail={setting?.companyName}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ชื่อบริษัท (อังกฤษ)"
        detail={setting?.companyNameEn}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Tax ID"
        detail={setting?.companyTaxId}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ที่อยู่"
        detail={setting?.companyAddress}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ที่อยู่สำหรับออกบิล"
        detail={setting?.companyAddressBilling}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ที่อยู่สำหรับออกบิล (English)"
        detail={setting?.companyAddressBillingEn}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="เบอร์โทร"
        detail={setting?.companyPhoneNumber}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="FAX"
        detail={setting?.companyPhoneFax}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Website"
        detail={setting?.website}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="อีเมล์"
        detail={setting?.companyEmail}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ชื่อสำหรับออก Cheuque (ไทย)"
        detail={setting?.companyChequeNameTh}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="ชื่อสำหรับออก Cheuque (อังกฤษ)"
        detail={setting?.companyChequeNameEn}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Bank Code"
        detail={setting?.companyBankCode}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Biller ID"
        detail={setting?.companyBillerId}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Reference Code"
        detail={setting?.referenceCode}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Swif CODE"
        detail={setting?.swifCode}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Bank Name"
        detail={setting?.bankName}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Bank Address"
        detail={setting?.bankAddress}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Bank Code Export"
        detail={setting?.branchCodeExport}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Branch Code"
        detail={setting?.branchCode}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Branch Name"
        detail={setting?.branchName}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Rate"
        detail={formatNumber(setting?.rate || 0, 4)}
      />
      <DetailItem
        customLabelClass="md:min-w-[240px]"
        label="Driver Link"
        detail={setting?.driverLink}
      />
    </div>
  );
};

export default CompanyMaintainView;
